import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { getFormStateDisplayStyles } from 'src/components/utils/stylingFunctions';
import { textStyleCss } from 'src/theme/atlas';
import { FormState } from 'src/types';
import styled from 'styled-components';

export const TopBannerStyled = styled.div<{
  state: FormState;
  $descriptionLineDrop?: boolean;
}>`
  display: flex;
  ${(props) => getFormStateDisplayStyles(props.state, props.theme)}
  gap: 20px;
  padding: 8px 20px;
  justify-content: space-between;
  align-items: center;
  width: calc(100vw - 40px);
  position: fixed;
  top: 0;
`;

export const TopBannerDescription = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
`;

export const CloseIcon = styled(StyledIcon)`
  cursor: pointer;
`;
